import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducers from '../reducers/rootReducer';

const persistConfig = {
  key: 'zwallet',
  storage,
  whitelist: ['user', 'transaction'],
};

const persistedReducer = persistReducer(persistConfig, rootReducers);
export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));
export const persistor = persistStore(store);
